import { LAYOUTS, } from "@voltmoney/types";
import { ColorTokens, IconTokens, VerificationCardButtonTypeToken, VerificationCardTypeTokens, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { ClosePopup } from "./actions";
import { heightMap } from "../../configs/height";
const _applyType = (type) => {
    switch (type) {
        case "DEFAULT":
            return VerificationCardTypeTokens.Default;
        case "SUCCESS":
            return VerificationCardTypeTokens.Success;
        case "IN_PROGRESS":
            return VerificationCardTypeTokens.InProgress;
        case "FAILED":
            return VerificationCardTypeTokens.Failed;
        case "LOADING":
            return VerificationCardTypeTokens.Default;
    }
};
export const template = ({ id, title, message, subTitle, iconName, primary, ctaLabel, ctaAction, type, isAutoTriggerCta = false, autoTriggerTimerInMilliseconds, titleFont = true, width = '100%', shouldAutoNavigate, }) => ({
    layout: {
        id: ROUTE.ALERT_PAGE,
        type: LAYOUTS.MODAL,
        style: {
            width: width,
            height: !subTitle || subTitle === "" ? heightMap[ROUTE.ALERT_PAGE_ONLY_TITLE] : heightMap[ROUTE.ALERT_PAGE],
        },
        widgets: [
            {
                id: "alert",
                type: WIDGET.VERIFICATIONCARD,
            },
        ],
    },
    datastore: {
        alert: {
            id,
            isAutoTriggerCta,
            autoTriggerTimerInMilliseconds,
            iconColor: ColorTokens.Primary_100,
            label: title || "",
            message: subTitle || "",
            type: _applyType(type),
            iconName: iconName || IconTokens.Alert,
            buttonText: ctaLabel,
            titleFont: titleFont,
            shouldAutoNavigate: shouldAutoNavigate,
            action: ctaAction ? ctaAction
                : {
                    type: ACTION.CLOSE_POPUP,
                    routeId: ROUTE.ALERT_PAGE,
                    payload: {},
                },
            buttonType: primary
                ? VerificationCardButtonTypeToken.FULL
                : VerificationCardButtonTypeToken.OUTLINE,
        },
    },
});
const alertPropsX = {
    title: "This is a Alert",
    subTitle: "Hello World",
    iconName: IconTokens.Alert,
    primary: true,
    ctaLabel: "continue",
    message: "Your data is secure with us",
    ctaAction: {
        type: ACTION.CLOSE_POPUP,
        routeId: ROUTE.ALERT_PAGE,
        payload: { hello: "world" },
    },
    type: "DEFAULT",
    isAutoTriggerCta: false,
    autoTriggerTimerInMilliseconds: 2000,
};
export const alertMF = {
    onLoad: async ({ ...props }, { alertProps }) => {
        console.warn("ALERT PROPS RECEIVED", alertProps.title, alertProps.subTitle);
        return Promise.resolve(template(alertProps));
    },
    actions: {
        [ACTION.CLOSE_POPUP]: ClosePopup,
    },
    clearPrevious: true,
};
